{
  "app": {
    "shellTitle": "Dink Product Admin · Consola de Plataforma",
    "loading": "Cargando"
  },
  "common": {
    "retry": "Reintentar",
    "close": "Cerrar",
    "menu": "Menú",
    "loading": "Cargando",
    "language": "Idioma",
    "comingSoon": "Próximamente",
    "noProgress": "Sin progreso"
  },
  "lang": { "en": "EN", "es": "ES", "fr": "FR", "pt": "PT" },
  "language_switcher": {
    "label": "Idioma",
    "options": {
      "en": "English",
      "es": "Español",
      "fr": "Français",
      "pt": "Português"
    }
  },
  "nav": {
    "signOut": "Cerrar sesión",
    "signIn": "Iniciar sesión",
    "group": { "operations": "Operaciones", "configuration": "Configuración" },
    "dashboard": "Panel",
    "queue": "Cola",
    "notifications": "Notificaciones",
    "logs": "Registros",
    "tenants": "Inquilinos",
    "engine": "Motor",
    "globalConfig": "Configuración global"
  },
  "shell": {
    "scope": "Plataforma — todos los inquilinos",
    "notificationsAriaLabel": "Notificaciones",
    "accountMenu": "Cuenta"
  },
  "page": {
    "dashboard": { "title": "Panel" },
    "queue": { "title": "Cola" },
    "notifications": { "title": "Notificaciones" },
    "logs": { "title": "Registros" },
    "tenants": { "title": "Inquilinos" },
    "engine": { "title": "Motor" },
    "globalConfig": { "title": "Configuración global" }
  },
  "bootstrap": {
    "error": "No se pudo cargar la configuración de la aplicación.",
    "errorNotRegistered": "Este host no está registrado. Contacte a su administrador.",
    "retry": "Reintentar"
  },
  "auth": {
    "redirecting": "Redirigiendo al inicio de sesión…",
    "returning": "Completando inicio de sesión…",
    "noAccessTitle": "No tienes acceso a esta consola",
    "noAccessBody": "Tu cuenta ha iniciado sesión, pero no se le ha concedido acceso a esta consola de administración de producto. Contacta con tu administrador si crees que se trata de un error.",
    "productAdminRequired": "Se requiere acceso de administrador de producto",
    "productAdminRequiredBody": "Has iniciado sesión, pero a tu cuenta no se le ha concedido acceso a esta consola de administración de producto.",
    "signedOutTitle": "Sesión cerrada",
    "signedOutBody": "Tu sesión de administrador de producto ha terminado.",
    "signInAgain": "Iniciar sesión de nuevo"
  },
  "errors": {
    "generic": "Algo salió mal. Inténtalo de nuevo.",
    "network": "Error de red. Comprueba tu conexión e inténtalo de nuevo.",
    "notFoundTitle": "No encontrado",
    "notFoundBody": "No pudimos encontrar lo que buscabas."
  },
  "help": {
    "ariaLabel": "Ayuda para {{label}}"
  }
}
